// Estados activos: customer, becado y cobranza. Archivado: subscriber.
// Solo un administrador distingue el rol real; el resto ve "Activo" o "Archivado".
// Solo afecta lo visible: el rol real sigue viajando en la respuesta de la API.
const ACTIVE_ROLES = ['customer', 'becado', 'cobranza'];

export const getRoleDisplay = (role, isAdmin) => {
  if (!ACTIVE_ROLES.includes(role)) return { key: 'subscriber', label: 'Archivado' };
  if (isAdmin && role === 'becado') return { key: 'becado', label: 'Becado' };
  if (isAdmin && role === 'cobranza') return { key: 'cobranza', label: 'Cobranza' };
  return { key: 'customer', label: 'Activo' };
};
